
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

// import utils
import { linkTracking } from '@utils/analytics/index';
import { withEnvironmentContext } from '@embeds/core/EnvironmentContext';
import useTextEditorContent from '@embeds/common/RichText/useTextEditorContent';


const PromotionalPreviewText = ({ sponsordata, id, type, envData, ...props }) => {
  const { promotionalText } = sponsordata;

  const handlerLinkPromotionalTextTracking = useCallback( (_e = {}, linkIndex) => {
    const prettyLinkIndex = (linkIndex + 1);
    const href = _e.currentTarget && _e.currentTarget.href;
    console.log('handlerLinkPromotionalTextTracking', href, _e);
    linkTracking(envData, { id, type }, `promotional-text-${ prettyLinkIndex }`, 0, { eVar25Suffix: 'promotional-text}', href } );
  }, [ id, type, envData ] );

  const promotionalTextRef = useTextEditorContent(promotionalText, handlerLinkPromotionalTextTracking);

  return (
    <div className="et-common_promotional" {...props}>
      <div className="et-common_promotional_text" ref={promotionalTextRef} ></div>
    </div>);
};

PromotionalPreviewText.propTypes = {
  sponsordata: PropTypes.object,
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  envData: PropTypes.object.isRequired,
};

PromotionalPreviewText.defaultProps = {
  sponsordata: {},
};

export default withEnvironmentContext(React.memo(PromotionalPreviewText));
